/** @jsx jsx */
import { Box, Flex, Paragraph } from "@eworkit/iris";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

interface SingleWorkStyleProps {
  type: string;
  score: number;
  WorkStyleIcon: any;
}

const COLOR_MAP = ["n200", "n300", "n500", "n700", "vg700", "vg600", "vg500"];

export const SingleWorkStyle: FunctionComponent<SingleWorkStyleProps> = ({ type, score, WorkStyleIcon }) => {
  const { t } = useTranslation("session");

  return (
    <Box borderRadius="lg" border="primary" key={type} borderColor="n100">
      <Flex p="xs" pr="sm" gap="xs" flexDirection="row" alignItems="center" justifyContent="space-between">
        <Flex
          alignItems="center"
          justifyContent="center"
          sx={{ bg: COLOR_MAP[score], minWidth: "32px", height: "32px", borderRadius: "4px" }}>
          <WorkStyleIcon size="sm" color="n0" />
        </Flex>
        <Flex flexGrow={1}>
          <Paragraph p-size="md">{t(`CONSULTANT_PROFILES.DETAIL.WORK_STYLES.TYPES.${type}.HEADER`)}</Paragraph>
        </Flex>
        <Flex sx={{ minWidth: 56 }} justifyContent="flex-end">
          <Box
            px="xs"
            borderRadius="md"
            backgroundColor="n50"
            sx={{
              py: "2px",
            }}>
            <Paragraph
              data-test={t(`CONSULTANT_PROFILES.DETAIL.WORK_STYLES.TYPES.${type}.HEADER`)}
              p-size="md"
              color="n700"
              sx={{
                fontWeight: 500,
              }}>
              {t(`CONSULTANT_PROFILES.DETAIL.WORK_STYLES.POINTS`, { count: score })}
            </Paragraph>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
